import { FC, useEffect } from "react";
import { useContentChannel } from "./ContentChannel";
import { TaskFlyout as TaskFlyoutPrimitive, TaskSubscription } from "capitalrx-components-2.0/lib/shell";

/** The `TaskFlyout` component properties. */
export interface TaskFlyoutProps {
  /**
   * Called when the task flyout visibility changes.
   */
  readonly onVisibilityChange?: (visible: boolean) => void;
}

/**
 * TaskFlyout's Shell adapter.
 * Handles channel subscription and transforms subscriptions into props for the primitive component.
 */
export const TaskFlyout: FC<TaskFlyoutProps> = (props) => {
  const { onVisibilityChange } = props;
  const subscriptions = useContentChannel(null, "flyout-tasks");

  const taskSubscriptions: ReadonlyArray<TaskSubscription> = subscriptions.map((subscription) => {
    const { component: Component, params } = subscription;
    return {
      component: Component,
      params,
    } as TaskSubscription;
  });

  useEffect(() => {
    if (taskSubscriptions.length === 0) {
      onVisibilityChange?.(false);
    } else {
      onVisibilityChange?.(true);
    }
  }, [taskSubscriptions.length, onVisibilityChange]);

  return <TaskFlyoutPrimitive subscriptions={taskSubscriptions} />;
};
